import React from 'react';
import { Section } from './Section';
import { CTAButton } from '../CTAButton';
export function Imagine() {
  return <Section tone="navy" data-id="element-180" data-mp="3fhmh0kkqjq9s">
      <h2 className="text-center font-display text-[1.7rem] font-bold leading-[1.15] tracking-tight text-white sm:text-4xl" data-id="element-181" data-mp="3fhwd8pwditnx">
        Imagine Walking Into Every Consultation Knowing{' '}
        <span className="text-gold" data-id="element-182" data-mp="35ixb7q645w9w">Exactly What To Do Next.</span>
      </h2>

      <div className="mt-8 grid gap-4" data-id="element-183" data-mp="3t912cy2483k0">
        <div className="rounded-2xl border border-white/10 bg-white/[0.06] p-5" data-id="element-184" data-mp="3ta2pw20biiim">
          <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-white/50" data-id="element-185" data-mp="216tlzpim02i">
            Instead of wondering
          </p>
          <p className="mt-2 font-display text-lg italic text-white/70 sm:text-xl" data-id="element-186" data-mp="3oh9krd0xt860">
            "Let me double-check the guideline first…"
          </p>
        </div>
        <div className="rounded-2xl border-2 border-gold/60 bg-gold/10 p-5" data-id="element-187" data-mp="g06fizln80uz">
          <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-gold" data-id="element-188" data-mp="kszlfqsulf8n">
            You'll think
          </p>
          <p className="mt-2 font-display text-lg font-bold italic text-white sm:text-xl" data-id="element-189" data-mp="6bf29xjq17jt">
            "I've already got the answer."
          </p>
        </div>
      </div>

      <p className="mt-6 text-center text-[15px] leading-relaxed text-white/75" data-id="element-190" data-mp="g1qjglsf1d8n">
        That's what the Menopause Clinical Blueprint™ delivers: a repeatable
        clinical system you can rely on every day.
      </p>

      <CTAButton className="mt-8" variant="gold" label="I want that confidence in every visit" data-id="element-191" data-mp="ozttaku1glkm" />
      <p className="mt-3 text-center text-[13px] text-white/60" data-id="element-192" data-mp="yzt1uhqgkbxh">
        One-time payment of $27 • 7-day money-back guarantee
      </p>
    </Section>;
}